import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmega, queryOmegaSingleResult } from "../api";
import { Package, PackageInstall } from "../types/package";

export const deletePackage: (config: {
  "package-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/delete-package Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const listPackages: (config: {
  limit: number;
  skip: number;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/list-packages Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const listInstalledPackages: (config: {
  "app-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/list-installed Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const installPackage: (config: {
  "app-id": string;
  "package-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/install-package Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const uninstallPackage: (config: {
  "app-id": string;
  "package-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/uninstall-package Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const writeComponentPackage: (config: {
  "app-id": string;
  "component-id": string;
  "package-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/write-component-package Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const deleteComponentPackage: (config: {
  "component-id": string;
  "package-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
        (= Input ${ednString})
        (Qo.Public.Api.Pkg/delete-component-package Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getPackage: (config: { "package-id": string }) => Promise<Package> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
    (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
    (Qo.Public.Api.Pkg/get-package ${ednString} Response)
    (return [Response])
  `;
  return queryOmegaSingleResult(query);
};

export const searchPackages: (config: { search: string }) => Promise<Package[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
    (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
    (Qo.Public.Api.Pkg/search-packages ${ednString} Response)
    (return [Response])
  `;
  return queryOmegaSingleResult(query);
};

export const setPackageDocs: (config: {
  "package-id": string;
  "docs-page-id": string;
}) => Promise<any> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.Pkg "omega/query-omega/public/api/pkg")
    (= DocsData ${ednString})
    (Qo.Public.Api.Pkg/set-package-docs DocsData Result)
    (return [Result])
  `;
  return queryOmegaSingleResult(query);
};
